import styles from './Notification.module.css';

interface NotificationProps {
  children: React.ReactNode;
  theme?: string;
}

export function Notification({ children, theme = 'neutral' }: NotificationProps) {
  return (
    <div className={styles.notification} data-theme={theme}>
      {children}
    </div>
  );
}
